import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface MenuOption {
  name: string;
  path: string;
  children?: MenuOption[];
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  gameModes: MenuOption[] = [
    { name: 'Basic', path: '/gameplay-basic' },
    { name: 'Epic', path: '/gameplay-epic' },
    { name: 'Legendary', path: '/gameplay-legendary' },
    { name: 'Mythical', path: '/gameplay-mythical' }
  ];

  currentYear = new Date().getFullYear();

  footerOptions: MenuOption[] = [
    { name: 'Privacy Policy', path: '/privacy-policy' },
  ];

  constructor(private router: Router) {}

  navigateToPrivacyPolicy() {
    // Navigate to privacy policy and scroll to top
    this.router.navigate([this.footerOptions[0].path]).then(() => {
      window.scrollTo(0, 0);
    });
  }
}